module.exports = __webpack_public_path__ + "static/media/list.2ab5f19b.png";